import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let providerSettingsMountPromise = null;

export function initProviderSettingsViewFragment({ onMounted } = {}) {
  registerViewMount('admin-provider-settings', () => mountProviderSettingsView(onMounted));
}

async function mountProviderSettingsView(onMounted) {
  if (document.getElementById('view-admin-provider-settings')) return;
  if (providerSettingsMountPromise) return providerSettingsMountPromise;

  providerSettingsMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');
    await appendTrustedAdminViewFragment(host, '/admin-views/provider-settings.html', 'Unable to load provider settings view');
    onMounted?.();
  })();

  try {
    await providerSettingsMountPromise;
  } catch (error) {
    providerSettingsMountPromise = null;
    throw error;
  }
}
